import script from "./AutoCompleteCidade.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoCompleteCidade.vue?vue&type=script&setup=true&lang=ts"

import "./AutoCompleteCidade.vue?vue&type=style&index=0&id=280907bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-280907bf"]])

export default __exports__